import { createRoutine } from 'redux-saga-routines'

export const SET = 'VOLUNTARIADO_LAYOUT/SET'
export const CONTENT = createRoutine('VOLUNTARIADO_LAYOUT/CONTENT')
